module.exports = __webpack_public_path__ + "static/media/mobile-banner-jp.51468e53.jpg";